import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { SIDEBAR_THEMES, DEFAULT_SIDEBAR_THEME } from '../theme/sidebarThemes'

/**
 * Sidebar-thema-store (BLOK 4) — de door de gebruiker gekozen sidebar-skin ('orion-blauw' | 'licht').
 *
 * localStorage-persist (patroon = navPanelStore/themeStore), zodat de keuze een refresh overleeft.
 * STAAT LOS van de app-brede dark/light-themeStore — twee onafhankelijke assen.
 * Onbekende/lege waarden (bij setThema óf bij het hydrateren van een corrupte localStorage) vallen
 * terug op de default ('orion-blauw').
 */
const geldigThema = (id) => (id && SIDEBAR_THEMES[id] ? id : DEFAULT_SIDEBAR_THEME)

export const useSidebarThemeStore = create(
  persist(
    (set) => ({
      actiefThema: DEFAULT_SIDEBAR_THEME,
      setThema: (id) => set({ actiefThema: geldigThema(id) }),
    }),
    {
      name: 'orion-sidebar-theme',
      version: 1,
      // Terugval op de default bij een onbekende/lege gepersisteerde waarde.
      merge: (persisted, current) => ({
        ...current,
        ...(persisted || {}),
        actiefThema: geldigThema(persisted?.actiefThema),
      }),
    },
  ),
)
